<template>
  <div>
    <RightTitle title="写消息"></RightTitle>
    <MessageTab position="write"></MessageTab>

    <!-- 表单 -->
    <div class="uar_form">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        size="medium"
        v-loading="loading"
        element-loading-text="正在提交，请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-form-item label="发送到">
          <el-input
            v-model="form.nickName"
            clearable
            placeholder="发送到"
            readonly
            style="width:250px;"
          ></el-input>
          <el-button style="margin-left:10px;" @click="selectFriend">选择好友</el-button>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.title" clearable placeholder="请输入标题" style="width:250px;"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            type="textarea"
            v-model="form.content"
            :autosize="{ minRows: 4, maxRows: 6}"
            placeholder="请输入内容"
            resize="none"
            clearable
            style="width:500px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitMessage">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 好友列表 -->
    <el-dialog title="选择好友" :visible.sync="dialogVisible" width="30%">
      <!-- 搜索表单 -->
      <el-form ref="form" :inline="true" :model="selectFriendForm" label-width="80px" size="medium">
        <el-form-item label="昵称">
          <el-input v-model="selectFriendForm.friendID" clearable placeholder="请输入好友ID搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchFriend">搜索</el-button>
        </el-form-item>
      </el-form>

      <!-- 好友列表 -->
      <div class="window-user-list" v-if="friendData.length > 0">
        <ul class="clear">
          <li
            v-for="(item, index) in friendData"
            :key="index"
            class="pointer"
            @click="confirmFriend(item)"
          >
            <div class="window-user-head">
              <img :src="item.head" />
            </div>
            <div class="window-user-nick inlineShow">{{ item.nick }}</div>
          </li>
        </ul>
      </div>
      <div class="noResult" v-else>暂无数据</div>

      <!-- 分页 -->
      <div class="page_area" v-if="friendData.length > 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="dataTotal"
          :page-size="12"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
import MessageTab from "../../components/MessageTab";
// 加载api
import { selectFriend } from "../../api/friend";
import { submitMessage } from "../../api/user_message";
export default {
  name: "write",
  components: {
    RightTitle,
    MessageTab
  },
  data() {
    return {
      form: {
        friendID: 0,
        nickName: "",
        title: "",
        content: ""
      },
      selectFriendForm: {
        friendID: ""
      },
      friendData: [],
      dataTotal: 0,
      dialogVisible: false,
      loading: false
    };
  },
  methods: {
    //   查找好友列表
    selectFriend() {
      this.dialogVisible = true;
      this.loadSelectFriend(1);
    },
    // 加载好友列表
    loadSelectFriend(page) {
      selectFriend({ friendID: this.selectFriendForm.friendID, page }).then(
        res => {
          this.friendData = res.data.list;
          this.dataTotal = res.data.count;
        }
      );
    },
    // 改变当前页
    currentChange(page) {
      this.loadSelectFriend(page);
    },
    // 搜索好友
    searchFriend() {
      this.loadSelectFriend(1);
    },
    // 确认好友
    confirmFriend(item) {
      this.form.friendID = item.userID;
      this.form.nickName = item.nick;
      this.dialogVisible = false;
    },
    // 提交消息
    submitMessage() {
      this.loading = true;
      submitMessage(this.form).then(res => {
        let that = this;
        if (res.status == 200) {
          this.$notify({
            title: "成功提示",
            message: "提交消息成功",
            type: "success",
            onClose: function() {
              that.$router.push({ name: "message.send" });
            }
          });
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning"
          });
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.window-user-list ul li {
  width: 120px;
  float: left;
  margin-left: 50px;
  margin-bottom: 20px;
  text-align: center;
}
.window-user-list ul li .window-user-head {
  width: 74px;
  height: 74px;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 auto;
}
.window-user-list ul li .window-user-head img {
  width: 74px;
  height: 74px;
}
.window-user-list ul li .window-user-nick {
  height: 25px;
  line-height: 25px;
}
</style>